type TabCountBadgeProps = {
    count: number
    variant: 'active' | 'inactive'
}

export function TabCountBadge({ count, variant }: TabCountBadgeProps) {
    const bgColorClass = variant === 'active' ? 'bg-brand-primary-emerald' : 'bg-content-secondary'

    return (
        <div
            className={`w-5 h-5 ${bgColorClass} rounded-full flex items-center justify-center text-white text-xs font-medium leading-none pt-[1px]`}
        >
            {count}
        </div>
    )
}
